import {
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AlertDialogData } from 'src/app/types';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ErrorDialogComponent {
  @Input() data!: AlertDialogData;

  constructor(protected bsModalRef: BsModalRef) {}

  get hasTitle(): boolean {
    return String(this.data.title || '').length > 0;
  }

  get title(): string {
    return this.data.title as string;
  }

  get message(): string {
    return this.data.message as string;
  }
}
